import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-49362902"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: _ctx.$attrs.id,
    "class": _normalizeClass(['tw-alert', _ctx.alrtClass]),
    role: "alert"
  }, [_renderSlot(_ctx.$slots, "default", {}, function () {
    return [_createTextVNode(_toDisplayString(_ctx.text), 1 /* TEXT */)];
  }, true)], 10 /* CLASS, PROPS */, _hoisted_1);
}